// =====================================
//
//   CMS 
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSProjectPostController", ['$scope', '$stateParams', '$rootScope', 'CMSService', '$PreviousState', '$compile',
    function($scope, $stateParams, $rootScope, CMSService, $PreviousState, $compile) {

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {
            
            var backState = $PreviousState.getLastState();

            if(backState == undefined) {
                backState = {
                    name: window.STATES.PROJECT_LIST,
                    params: {}
                };
            }
            
            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 取得部落格文章
        // --------------------------------
        var getProjectPost = function() {

            if($scope.isLoading || !$scope.slug) {
                return;
            }

            $scope.isLoading = true;

            CMSService.getProjectPost($scope.slug).then(function(result) {

                if(result) {
                    $scope.post = result;
                } else {
                    $scope.isError = true;
                }

                $scope.isLoading = false;

                getProjcetRecommendPost();

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
            })
        }

        // --------------------------------
        // 取得推薦文章
        // --------------------------------
        var getProjcetRecommendPost = function() {

            var categories = [];

            if($scope.post.categories && $scope.post.categories.length > 0) {
                for(var i = 0; i < $scope.post.categories.length; i++) {
                    categories.push($scope.post.categories[i]._id);
                }
            }

            CMSService.getProjcetRecommendPost($scope.post._id, categories).then(function(result) {

                if(result) {
                    $scope.recommendList = result;
                }
            });
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {

            getProjectPost();
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            if(fromState.name == window.STATES.PROJECT_LIST) {
                $scope.backParams = fromParams;
            } else {
                $scope.backParams = undefined;
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.slug = $stateParams.slug;
        $scope.post;
        $scope.recommendList = [];
        $scope.backParams = undefined;

        //==========================
        //  Methods
        //==========================
        $scope.goBack = goBack;

        //==========================
        //  Init
        //==========================
        init();
    }
]);